import clsx from "clsx";

const SPINNER_SIZES = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-12 w-12",
} as const;

const SPINNER_COLORS = {
  primary: "text-primary-500",
  white: "text-white",
  gray: "text-raro-gray-400",
} as const;

export function getSpinnerClasses(
  size: keyof typeof SPINNER_SIZES,
  color: keyof typeof SPINNER_COLORS
): string {
  return clsx(SPINNER_SIZES[size], SPINNER_COLORS[color]);
}
